export const getRandomName = () => {

  const adjectives = [
    "Neon","Shadow","Dark","Silent","Rapid",
    "Blue","Red","Cyber","Iron","Ghost"
  ];

  const nouns = [
    "Tiger","Wolf","Fox","Falcon","Blade",
    "Wave","Core","Pixel","Storm","Knight"
  ];

  const adj =
    adjectives[Math.floor(Math.random()*adjectives.length)];

  const noun =
    nouns[Math.floor(Math.random()*nouns.length)];

  const num =
    Math.floor(Math.random()*1000);

  return `${adj}${noun}${num}`;
};